import {useSiteMessage} from "@/providers/SiteMessageProvider";
import {apiPost} from "@/services/apiService";
import {formValidation} from "@/utils/formValidation";

export default function useSignUpForm(agrees: boolean = false, setSubmitting?: (submitting: boolean) => void) {
    const {setMessage} = useSiteMessage();

    const signupSubmit = async (values) => {
        const errors = formValidation(values);

        if (Object.keys(errors)?.length > 0) {
            setMessage(Object.values(errors).join("\n"));

            return false;
        }

        if (!agrees) {
            setMessage('You must agree to the terms and conditions before you can join.');

            return false;
        }

        if (setSubmitting) {
            setSubmitting(true);
        }

        const body = JSON.stringify(values, null, 2);

        const response = await apiPost('/account', body, undefined, {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        const json = await response.json();

        if (setSubmitting) {
            setSubmitting(false);
        }

        if (json.error) {
            throw new Error(json.error);
        }

        gtag('event', 'sign_up');

        return true;
    };

    return {signupSubmit};
}